import React from "react";
/** Components Import */
import Card from "../Card_wrap";
import BasicInput from "../Input_Basic";
import BasicSwitch from "../Switch_Basic";

function BarcodeArea({
  autoFocus,
  wrapStyle,
  containerStyle = {
    width: "360px",
    height: "10vh",
    display: "flex",
    justifyContent: "space-between",
  },
  inputStyle,
  placeholder = "Barcode",
  inputValue,
  onInputChange = (e) => {},
  onInputKeyDown = (e) => {},
  onInputKeyUp = (e) => {},
  onInputClick = (e) => {},
  inputMode = "none",
  inputType = "text",
  switchValue,
  inputRef,
  onSwitchChange = (e) => {},
}) {
  const InputChanged = (e) => {
    onInputChange(e.target.value);
    navigator.clipboard.writeText(e.target.value);
  };

  const InputKeyDown = (e) => {
    if (e.keyCode === 13) {
      onInputKeyDown(e.target.value);
    }
  };
  const InputKeyUp = (e) => {
    if (e.keyCode === 13) {
      onInputKeyUp(e.target.value);
    }
  };

  const InputClick = (e) => {
    onInputClick(e.target.value);
  };

  const SwitchChanged = (e) => {
    onSwitchChange(e.target.checked);
  };

  return (
    <div style={wrapStyle}>
      <Card wrapStyle={containerStyle}>
        <input
          className="barcode_area_input"
          style={inputStyle}
          type={inputType}
          placeholder={placeholder}
          value={inputValue}
          onChange={InputChanged}
          onKeyDown={InputKeyDown}
          onKeyUp={InputKeyUp}
          onClick={InputClick}
          inputMode={switchValue ? "text" : inputMode}
          autoFocus={autoFocus}
          ref={inputRef}
        />
        <BasicSwitch value={switchValue} onChange={SwitchChanged} />
      </Card>
    </div>
  );
}

BarcodeArea.defaultProps = {};

export default BarcodeArea;
